import { roundToNearestMinutes } from 'date-fns';
import { isSessionEnded } from '@tools/sessionUtils/SessionStatus';

const minute = 60000;
const hour = 60 * minute;

/**
 * Given an end time and interval, returns a randomized delay in milliseconds.
 * e.g. end = 10:00, interval = 5, returns a random delay in milliseconds from
 *      now until random time between 9:55 and 10:00
 *
 * @param now Current time
 * @param end End time
 * @param interval Range in minutes
 * @returns delay in milliseconds
 */
export const getRandomizedQueryDelay = (now, end, interval) => {
  if (isSessionEnded(now, end, interval)) {
    // If user joined session within query interval, query immediately
    return 1;
  }
  const intervalEnd = new Date(end).getTime();
  const randomDate = new Date(
    intervalEnd - Math.floor(Math.random() * Math.floor(interval * 60 * 1000))
  );
  return randomDate.getTime() - now.getTime();
};

/**
 * Round current time to nearest minute interval for better caching
 * @param {*} now Current time
 * @param {*} nearestTo Minute interval (default: 1)
 * @returns ISO timestamp
 */
export const getSessionQueryStart = (
  now = new Date().toISOString(),
  nearestTo = 1
) => {
  const roundedDate = roundToNearestMinutes(new Date(now), { nearestTo });
  const start = roundedDate.toISOString();

  return start;
};

export const searchScheduleCriteria = start => {
  return {
    start,
    end: new Date(new Date(start).getTime() + 2 * hour).toISOString()
  };
};

const getUpcomingSessionsSearchCriteria = now => {
  const start = getSessionQueryStart(now);

  return {
    pageCriteria: {
      limit: 25
    },
    liveAndUpcoming: {
      start
    }
  };
};

export default getUpcomingSessionsSearchCriteria;
